import React from 'react';
import { LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { useAsyncState } from '@/utils/hooks';
import { hasConfig } from '@/services/booking';
import BookameraIntegrationStatus from './BokameraIntegrationStatus';
import BokameraIntegrationServiceList from './BokameraIntegrationServiceList';

interface BookameraIntegrationProps {
    projectId: number;
}

const BookameraIntegration = ({ projectId }: BookameraIntegrationProps) => {
    const [hasIntegration, , reload] = useAsyncState(async () => await hasConfig(projectId), [projectId], null);
    return (
        <div>
            {hasIntegration === null && <LoadingIndicator />}
            {hasIntegration !== null && (
                <BookameraIntegrationStatus
                    projectId={projectId}
                    hasIntegration={hasIntegration}
                    reloadHasIntegration={reload}
                />
            )}
            {hasIntegration === true && <BokameraIntegrationServiceList projectId={projectId} />}
        </div>
    );
};
export default BookameraIntegration;
